const o = "SimcaptureUIComponents:";
export {
  o as C
};
//# sourceMappingURL=constants-BT275Ljt.js.map
